import { render, staticRenderFns } from "./ReservationColumn.vue?vue&type=template&id=1921229a&scoped=true&"
import script from "./ReservationColumn.vue?vue&type=script&lang=js&"
export * from "./ReservationColumn.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumn.vue?vue&type=style&index=0&id=1921229a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921229a",
  null
  
)

export default component.exports